import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "controls"
}
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "created-at" }
const _hoisted_4 = { class: "size" }
const _hoisted_5 = {
  key: 0,
  class: "controls"
}

import FilePreview from 'SharedComponents/ui/File/FilePreview.vue';
import FloatingWindow from 'SharedComponents/ui/File/FloatingWindow.vue';
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { previewKnowFiles } from 'SharedDir/constants/files';
import { computed, ref } from 'vue';
import { Colors, FsView } from 'SharedDir/constants/file-system';
import { AttachmentType } from 'SharedDir/declarations/files';
import useFileApi from 'SharedDir/common/composables/useFileApi';
import {
  convertUTCToLocal,
  toRussianLocaleDateTimeFromIso,
} from '@packages/toolbox/dist/utils/datetime';

const NoneColor = 'gray';

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'Attachment' },
  __name: 'Attachment',
  props: {
    data: {},
    view: { default: FsView.tile },
    tag: { default: 'div' },
    hidePreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

/* eslint-disable @typescript-eslint/naming-convention,no-underscore-dangle */
const knowFiles = [
  'bmp',
  'csv',
  'doc',
  'docx',
  // 'folder',
  'jpg',
  'ods',
  'pdf',
  'png',
  'ppt',
  'rar',
  'rtf',
  'sig',
  'txt',
  // 'unknown',
  'xlsx',
  'xml',
  'zip',
];


const props = __props;
const { downloadFile } = useFileApi();

const ext = computed(() => {
  if (props.data.extension) {
    return props.data.extension.toLowerCase();
  }
  return '';
});

const isTile = computed(() => {
  return props.view === FsView.tile;
});

const fullName = computed(() => {
  const ext_ = ext.value ? `.${ext.value}` : '';
  return `${props.data.name}${ext_}`;
});

const extCode = computed(() => {
  if (!ext.value) {
    return null;
  }
  return ext.value
    ?.split('')
    .map((char) => char.charCodeAt(0))
    .reduce((a, b) => a + b, 0);
});

const iconName = computed(() => {
  if (ext.value && knowFiles.includes(ext.value)) {
    return `custom:files/${ext.value}`;
  }

  return 'custom:files/unknown';
});
const mainStyle = computed(() => {
  let background = NoneColor;
  if (extCode.value) {
    const index = extCode.value % Colors.length;
    const c = Colors[index];
    background = `hsl(${c.saturation}, ${c.lightness}%, ${c.alpha * 1.7}%)`;
  }
  return { background };
});

const extStyle = computed(() => {
  let background = NoneColor;
  if (extCode.value) {
    const index = extCode.value % Colors.length;
    const c = Colors[index];
    background = `hsl(${c.saturation}, ${c.lightness}%, ${c.alpha}%)`;
  }
  return { background };
});

const fileSize = computed(() => {
  const units = ['Б', 'КБ', 'МБ'].reverse();
  let unit = units.pop();
  const step = 1024;
  let { size } = props.data;
  if (!size) {
    return '? КБ';
  }
  let times = size;
  while (units.length > 0 && times > step) {
    size /= step;
    times = size % step;
    unit = units.pop();
  }
  return `${Intl.NumberFormat('ru-ru').format(Math.round(size))} ${unit}`;
});

const fileDate = computed(() => {
  if (!props.data.createdAt) {
    return '';
  }
  return toRussianLocaleDateTimeFromIso(convertUTCToLocal(props.data.createdAt).toISOString());
});

const showPreview = ref(false);
const floatingWindowSize = computed(() =>
  ext.value === 'pdf' ? undefined : { height: 750, width: 875 }
);
const previewIconName = computed(() => (showPreview.value ? 'app:eye-close' : 'app:eye'));
const previewable = computed(() => {
  return previewKnowFiles.includes(ext.value);
});

return (_ctx: any,_cache: any) => {
  return (isTile.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
        key: 0,
        class: "attachment tile",
        style: _normalizeStyle(mainStyle.value)
      }, {
        default: _withCtx(() => [
          (ext.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "type",
                style: _normalizeStyle(extStyle.value)
              }, _toDisplayString(ext.value.toUpperCase()), 5))
            : _createCommentVNode("", true),
          (previewable.value && !_ctx.hidePreview)
            ? (_openBlock(), _createBlock(SIcon, {
                key: 1,
                class: "preview-button",
                color: "grey",
                name: previewIconName.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showPreview.value = !showPreview.value))
              }, null, 8, ["name"]))
            : _createCommentVNode("", true),
          (_ctx.$slots.default)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: "name",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(downloadFile)(_ctx.data.id)))
          }, _toDisplayString(_ctx.data.name), 1),
          (showPreview.value && !_ctx.hidePreview)
            ? (_openBlock(), _createBlock(FloatingWindow, {
                key: 3,
                title: fullName.value,
                size: floatingWindowSize.value,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (showPreview.value = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(FilePreview, { fileData: _ctx.data }, null, 8, ["fileData"])
                ]),
                _: 1
              }, 8, ["title", "size"]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["style"]))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
        key: 1,
        class: "attachment bar"
      }, {
        default: _withCtx(() => [
          _createVNode(SIcon, {
            name: iconName.value,
            size: "large"
          }, null, 8, ["name"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(downloadFile)(_ctx.data.id)))
            }, _toDisplayString(fullName.value), 1)
          ]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(fileDate.value), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(fileSize.value), 1),
          _createElementVNode("div", null, [
            (previewable.value && !_ctx.hidePreview)
              ? (_openBlock(), _createBlock(SIcon, {
                  key: 0,
                  class: "preview-button",
                  color: "grey",
                  name: previewIconName.value,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showPreview.value = !showPreview.value))
                }, null, 8, ["name"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.$slots.default)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "default")
              ]))
            : _createCommentVNode("", true),
          (showPreview.value && !_ctx.hidePreview)
            ? (_openBlock(), _createBlock(FloatingWindow, {
                key: 1,
                title: fullName.value,
                size: floatingWindowSize.value,
                onClose: _cache[5] || (_cache[5] = ($event: any) => (showPreview.value = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(FilePreview, { fileData: _ctx.data }, null, 8, ["fileData"])
                ]),
                _: 1
              }, 8, ["title", "size"]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }))
}
}

})